
import React from 'react';
import { Trash2, X } from 'lucide-react';
import { Button } from './ui/Button';

interface BulkActionsBarProps {
  selectedCount: number;
  onClear: () => void;
  onDelete: () => void;
  children?: React.ReactNode;
}

export const BulkActionsBar: React.FC<BulkActionsBarProps> = ({ selectedCount, onClear, onDelete, children }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 bg-white dark:bg-slate-800 px-6 py-3 rounded-ds-card shadow-ds-card flex items-center gap-4 animate-fade-in border border-slate-200 dark:border-slate-700">
      <div className="flex items-center gap-3 border-r border-slate-200 dark:border-slate-700 pr-4">
        <span className="text-ds-body font-medium text-slate-900 dark:text-white whitespace-nowrap">{selectedCount} vybrano</span>
        <button onClick={onClear} className="p-1 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-ds-button transition-colors text-slate-400 hover:text-slate-600 dark:hover:text-slate-300">
          <X size={14} />
        </button>
      </div>
      
      <div className="flex items-center gap-2">
        {children}
        <Button 
          variant="danger"
          size="sm"
          onClick={onDelete}
          icon={<Trash2 size={16} />}
        >
          Smazat
        </Button>
      </div>
    </div>
  );
};
